import { PricingService } from '@spilca/order_ts/v1/order_web/pricing_web_pb_service';
import { pricingRequestConstructor } from '@monorepo/pricing';

const getPriceLists = (filter: object | undefined) =>
  pricingRequestConstructor(filter, PricingService.ListPricing);

export default getPriceLists;
